<template>
  <div class="min-h-[calc(100vh-140px)]">
    <section
      class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]"
    >
      <div
        class="grid min-h-[520px] grid-cols-1 lg:grid-cols-[minmax(0,1fr)_380px]"
      >
        <div class="flex flex-col justify-between p-8 lg:p-10">
          <div>
            <div
              class="inline-flex items-center gap-2 rounded-full border border-rose-100 bg-rose-50 px-3 py-1.5 text-sm font-bold text-rose-700"
            >
              <i class="pi pi-exclamation-circle text-sm"></i>
              <span>Route không tồn tại</span>
            </div>

            <div class="mt-10 max-w-3xl">
              <div class="text-[84px] font-black leading-none text-slate-900">
                404
              </div>
              <h1 class="mt-4 text-4xl font-black leading-tight text-slate-900">
                Không tìm thấy trang bạn yêu cầu
              </h1>
              <p class="mt-4 max-w-2xl text-[16px] font-medium leading-7 text-slate-500">
                Đường dẫn có thể đã bị đổi, bị xóa, hoặc bạn đang truy cập nhầm
                địa chỉ. Hãy quay về màn hình gửi tin nhắn để tiếp tục thao tác.
              </p>
            </div>
          </div>

          <div class="mt-10 flex flex-wrap items-center gap-3">
            <Button
              label="Về trang gửi tin nhắn"
              icon="pi pi-send"
              iconPos="left"
              @click="goTo('/sendmessage')"
            />
            <Button
              label="Quay lại"
              icon="pi pi-arrow-left"
              iconPos="left"
              outlined
              @click="goBack()"
            />
          </div>
        </div>

        <aside
          class="border-t border-slate-200 bg-slate-50 p-6 lg:border-l lg:border-t-0"
        >
          <div class="rounded-lg border border-slate-200 bg-white p-5">
            <div class="flex items-center gap-3">
              <div
                class="flex h-10 w-10 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
              >
                <i class="pi pi-link text-sm"></i>
              </div>
              <div class="min-w-0">
                <div class="text-sm font-black text-slate-900">
                  Đường dẫn hiện tại
                </div>
                <div class="mt-0.5 truncate text-sm font-medium text-slate-500">
                  {{ $route.fullPath }}
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 rounded-lg border border-slate-200 bg-white p-5">
            <div class="text-sm font-black text-slate-900">
              Màn hình thường dùng
            </div>
            <div class="mt-4 flex flex-col gap-2">
              <Button
                v-for="item in quickLinks"
                :key="item.to"
                :label="item.label"
                :icon="`pi ${item.icon}`"
                iconPos="left"
                outlined
                class="!justify-start !border-slate-200 !bg-white !text-slate-700 hover:!bg-teal-50 hover:!text-teal-800"
                @click="goTo(item.to)"
              />
            </div>
          </div>
        </aside>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const quickLinks = [
      { label: "Gửi tin nhắn", icon: "pi-send", to: "/sendmessage" },
      { label: "Đăng hình ảnh", icon: "pi-upload", to: "/uploadImage" },
      { label: "Quản lý nhóm", icon: "pi-plus-circle", to: "/managerGroup" },
    ];

    const goTo = (path: string) => {
      router.push(path);
    };

    const goBack = () => {
      router.back();
    };

    return { quickLinks, goTo, goBack };
  },
};
</script>
